"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToastSuccess = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _kDsFoundation = _interopRequireDefault(require("../../lib/k-ds-foundation"));
var _ToastBase = require("./ToastBase");
var _excluded = ["message", "onClick"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var IconSuccess = function IconSuccess(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M26.339 14.088c0 6.766-5.485 12.25-12.25 12.25-6.766 0-12.25-5.484-12.25-12.25 0-6.765 5.484-12.25 12.25-12.25 6.765 0 12.25 5.485 12.25 12.25Z",
    fill: "#8BC34A"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M21.061 8.8a1.228 1.228 0 0 1-.005 1.737l-8.826 8.77a1.842 1.842 0 0 1-2.601-.004l-2.426-2.426a1.228 1.228 0 1 1 1.737-1.736l1.993 1.993 8.391-8.34a1.228 1.228 0 0 1 1.737.006Z",
    fill: "#fff"
  }));
};
IconSuccess.defaultProps = {
  width: "28",
  height: "28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var IconClose = function IconClose(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m7 5.586 4.95-4.95 1.414 1.414L8.414 7l4.95 4.95-1.414 1.414L7 8.414l-4.95 4.95L.636 11.95 5.586 7 .636 2.05 2.05.636 7 5.586Z",
    fill: "#18223D"
  }));
};
IconClose.defaultProps = {
  width: "14",
  height: "14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var StyledToastSuccess = /*#__PURE__*/(0, _styledComponents["default"])(_ToastBase.ToastBase).withConfig({
  componentId: "kds-v1__sc-gqe5zi-0"
})(["", ";"], _kDsFoundation["default"].setColorTokenWithFallback('border: 2px solid ', 'successful'));
var ToastSuccess = exports.ToastSuccess = function ToastSuccess(_ref) {
  var message = _ref.message,
    onClick = _ref.onClick,
    moreProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(StyledToastSuccess, moreProps, /*#__PURE__*/_react["default"].createElement(IconSuccess, {
    className: "toast-icon"
  }), /*#__PURE__*/_react["default"].createElement("p", {
    className: "k-ds-heading-01 toast-message"
  }, message), /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "toast-close",
    onClick: onClick
  }, /*#__PURE__*/_react["default"].createElement(IconClose, null)));
};